import { useState } from "react";
import { Mail, Send } from "lucide-react";
import { motion } from "framer-motion";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { z } from "zod";

const emailSchema = z.string().trim().email("E-mail inválido").max(255, "E-mail muito longo");

const EmailCapture = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const result = emailSchema.safeParse(email);
    if (!result.success) {
      toast.error(result.error.errors[0].message);
      return;
    }

    setLoading(true);
    try {
      const { error } = await (supabase as any)
        .from("email_subscribers")
        .insert({ email: result.data });

      if (error) {
        if (error.code === "23505") {
          toast.info("Você já está inscrito! 🎶");
        } else {
          throw error;
        }
      } else {
        toast.success("Inscrito com sucesso! Você receberá novos hinos toda semana. 🎵");
        setEmail("");
      }
    } catch {
      toast.error("Erro ao se inscrever. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 bg-[hsl(220,20%,8%)]">
      <div className="container mx-auto max-w-xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-14 h-14 rounded-full bg-amber-500/15 flex items-center justify-center mx-auto mb-5">
            <Mail className="h-7 w-7 text-amber-400" />
          </div>
          <h2
            className="text-2xl md:text-3xl font-bold text-white mb-3"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Receba novos hinos toda semana
          </h2>
          <p className="text-white/50 mb-8 text-base">
            Gratuitamente no seu e-mail. Sem spam, apenas louvores.
          </p>
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu melhor e-mail"
              required
              maxLength={255}
              className="flex-1 px-5 py-3.5 rounded-xl bg-white/10 border border-white/10 text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500/50 transition-all duration-300 text-base"
            />
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-3.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white font-semibold flex items-center justify-center gap-2 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-amber-500/30 disabled:opacity-50 disabled:hover:scale-100"
            >
              <Send className="h-4 w-4" />
              {loading ? "Enviando..." : "Inscrever"}
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default EmailCapture;
